module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/bn2dpn/tc-custom/9781514004623.jpg?1688600506308",
      "alt": "This image is the cover for the book Message of Deuteronomy"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Message of Deuteronomy\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_c('strong', [_vm._v("No Old Testament book has exerted a greater influence on the formation of both Jewish and Christian thought and practice than Deuteronomy.")]), _vm._v(" It presents the final message of Moses to the people of Israel, providing foundational theology for the rest of Scripture. When we read Deuteronomy today, we hear Moses address us as a future generation of the covenant people of God. The challenges and needs faced by the Israelites still resonate with believers in every new era. Raymond Brown's"), _c('em', [_vm._v("The Message of Deuteronomy")]), _vm._v(" guides Christians to hear and appreciate the timeless relevance of this ancient message. Brown's compilation of historical and biblical background complements his even-handed, insightful commentary while maintaining a readable style. Uncover the choice between blessings and curses, life and death laid out in Deuteronomy. This revised edition of a classic Bible Speaks Today volume features lightly updated language, current NIV Scripture quotations, and a new interior design.")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Raymond Brown\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }), _c('p', [_vm._v("Raymond Brown, formerly principal of Spurgeon's College in London, was a pastor for many years. He is the author of "), _c('em', [_vm._v("Philosophy of Religion")]), _vm._v(", "), _c('em', [_vm._v("Why Believe?")]), _vm._v(", and several volumes in IVP's Bible Speaks Today series.")]), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    InterVarsity Press\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0